export default "__VITE_ASSET__DSVGxpNP__"